var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIlustracartao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12808_205343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.014 116.157L14.6578 99.3298C10.0554 98.5028 6.96311 94.1161 7.7901 89.5137L17.6421 33.7095C18.4691 29.1071 22.8558 26.0149 27.4582 26.8419L122.814 43.6694C127.417 44.4964 130.509 48.8831 129.682 53.4855L119.83 109.29C119.039 113.892 114.616 116.984 110.014 116.157Z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9883 54.3389L16.5413 39.8563L128.578 59.606L126.025 74.0886L13.9883 54.3389Z",
    fill: "#2B374A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3851 86.4576L19.7987 75.7786C18.3604 75.5269 17.3896 74.1246 17.6413 72.6864C17.893 71.2481 19.2953 70.2773 20.7335 70.529L81.3199 81.208C82.7582 81.4597 83.729 82.862 83.4773 84.3003C83.2256 85.7385 81.8233 86.7093 80.3851 86.4576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2415 93.145L18.1815 85.0188C16.7432 84.7671 15.7724 83.3648 16.0241 81.9266C16.2758 80.4883 17.6781 79.5175 19.1163 79.7692L65.1764 87.8953C66.6146 88.147 67.5855 89.5493 67.3338 90.9876C67.0821 92.4258 65.7157 93.3966 64.2415 93.145Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.761,
    cy: 85.1629,
    rx: 20.1355,
    ry: 20.1355,
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.271 72.7578H113.143C112.783 72.7578 112.46 73.0814 112.46 73.4769L112.855 89.909H116.595L116.99 73.4769C116.99 73.0814 116.667 72.7578 116.271 72.7578ZM112.82 96.8486C113.323 97.352 114.006 97.6037 114.761 97.6037C115.516 97.6037 116.199 97.3161 116.703 96.8486C117.206 96.3812 117.458 95.698 117.458 94.9429C117.458 94.1879 117.242 93.5406 116.703 93.0013C116.199 92.4979 115.516 92.2462 114.761 92.2462C114.006 92.2462 113.359 92.4619 112.82 93.0013C112.316 93.5047 112.064 94.1879 112.064 94.9429C112.064 95.698 112.28 96.3093 112.82 96.8486Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12808_205343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustracartao);
export default __webpack_public_path__ + "_checkout/static/media/ilustracartao.5045be21d62d462acc51f434c8f50be6.svg";
export { ForwardRef as ReactComponent };